/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportAddRewardLedgerEntryRequest
 */
export interface SupportAddRewardLedgerEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof SupportAddRewardLedgerEntryRequest
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof SupportAddRewardLedgerEntryRequest
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof SupportAddRewardLedgerEntryRequest
     */
    currency?: SupportAddRewardLedgerEntryRequestCurrencyEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SupportAddRewardLedgerEntryRequest
     */
    pending?: boolean;
}


/**
 * @export
 */
export const SupportAddRewardLedgerEntryRequestCurrencyEnum = {
    Usd: 'USD'
} as const;
export type SupportAddRewardLedgerEntryRequestCurrencyEnum = typeof SupportAddRewardLedgerEntryRequestCurrencyEnum[keyof typeof SupportAddRewardLedgerEntryRequestCurrencyEnum];


/**
 * Check if a given object implements the SupportAddRewardLedgerEntryRequest interface.
 */
export function instanceOfSupportAddRewardLedgerEntryRequest(value: object): value is SupportAddRewardLedgerEntryRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function SupportAddRewardLedgerEntryRequestFromJSON(json: any): SupportAddRewardLedgerEntryRequest {
    return SupportAddRewardLedgerEntryRequestFromJSONTyped(json, false);
}

export function SupportAddRewardLedgerEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportAddRewardLedgerEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'amount': json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'pending': json['pending'] == null ? undefined : json['pending'],
    };
}

export function SupportAddRewardLedgerEntryRequestToJSON(json: any): SupportAddRewardLedgerEntryRequest {
    return SupportAddRewardLedgerEntryRequestToJSONTyped(json, false);
}

export function SupportAddRewardLedgerEntryRequestToJSONTyped(value?: SupportAddRewardLedgerEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'amount': value['amount'],
        'currency': value['currency'],
        'pending': value['pending'],
    };
}

